export enum SirdataListField {
    LAST_UPDATED = "lastUpdated",
    STACKS = "stacks",
    VENDORS = "vendors",
    PURPOSES = "purposes"
}
